import React, { useState, useEffect } from "react";
import InvoiceReceipt from "./invoice-receipt";

const COURSE_PRICING = {
  offline: {
    name: "IAS Jnani Civil Services Foundation Program (Offline)",
    totalFee: 75000,
    gstPercent: 18,
  },
  online: {
    name: "IAS Jnani Civil Services Foundation Program (Online)",
    totalFee: 65000,
    gstPercent: 18,
  },
};

const InvoiceWrapper = () => {
  const [studentData, setStudentData] = useState({
    name: "",
    email: "",
    mobile: "",
    studentId: "",
    courseMode: "offline",
    discount: 0,
    amountReceived: 0,
    paymentMode: "",
  });

  const [calculated, setCalculated] = useState({});

  useEffect(() => {
    const course = COURSE_PRICING[studentData.courseMode];

    const baseAmount = course.totalFee / (1 + course.gstPercent / 100);
    const gstAmount = course.totalFee - baseAmount;

    const finalAmount = course.totalFee - Number(studentData.discount || 0);

    const due = finalAmount - Number(studentData.amountReceived || 0);

    setCalculated({
      courseName: course.name,
      baseAmount,
      gstAmount,
      total: course.totalFee,
      finalAmount,
      due,
    });
  }, [studentData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setStudentData({ ...studentData, [name]: value });
  };

  return (
    <>
      <div className="invoice-form-container">
        <h3>Student Invoice Entry</h3>

        <form>
          <input
            type="text"
            name="name"
            placeholder="Student Name"
            onChange={handleChange}
            className="form-control mb-2"
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            onChange={handleChange}
            className="form-control mb-2"
          />

          <input
            type="text"
            name="mobile"
            placeholder="Mobile"
            onChange={handleChange}
            className="form-control mb-2"
          />

          <select
            name="courseMode"
            onChange={handleChange}
            className="form-control mb-2"
          >
            <option value="offline">Offline Program</option>
            <option value="online">Online Program</option>
          </select>

          <input
            type="number"
            name="discount"
            placeholder="Discount"
            onChange={handleChange}
            className="form-control mb-2"
          />

          <input
            type="number"
            name="amountReceived"
            placeholder="Amount Received"
            onChange={handleChange}
            className="form-control mb-2"
          />

          <select
            name="paymentMode"
            onChange={handleChange}
            className="form-control mb-2"
          >
            <option value="">Payment Mode</option>
            <option value="Cash">Cash</option>
            <option value="UPI">UPI</option>
            <option value="Bank Transfer">Bank Transfer</option>
          </select>
        </form>
      </div>

      <InvoiceReceipt studentData={studentData} calculated={calculated} />
    </>
  );
};

export default InvoiceWrapper;
